import { createReducer, INITIAL_STATE } from '../../../shared/redux';

export const SIGN_UP_SUBMITTED = '@auth/SIGN_UP_SUBMITTED';
export const SIGN_UP_ACCEPTED = '@auth/SIGN_UP_ACCEPTED';
export const SIGN_UP_REJECTED = '@auth/SIGN_UP_REJECTED';
export const SIGN_UP_CONFIRMATION_ISSUED = '@auth/SIGN_UP_CONFIRMATION_ISSUED';
export const SIGN_UP_UNKNOWN_EXCEPTION_RAISED = '@auth/SIGN_UP_UNKNOWN_EXCEPTION_RAISED';
export const SIGN_UP_GO_BACK_STEP = '@auth/SIGN_UP_GO_BACK_STEP';
export const SIGN_UP_STEP_SUBMIT_REQUESTED = '@auth/SIGN_UP_STEP_SUBMIT_REQUESTED';
export const SIGN_UP_STEP_SUBMIT_ACCEPTED = '@auth/SIGN_UP_STEP_SUBMIT_ACCEPTED';
export const SIGN_UP_STEP_SUBMIT_REJECTED = '@auth/SIGN_UP_STEP_SUBMIT_REJECTED';
export const SIGN_UP_STEP_SET = '@auth/SIGN_UP_STEP_SET';
export const SIGN_UP_DATA_SET = '@auth/SIGN_UP_DATA_SET';
export const SIGN_UP_RESET = '@auth/SIGN_UP_RESET';
export const SIGN_UP_VALIDATE_USERNAME = '@auth/SIGN_UP_VALIDATE_USERNAME';
export const SIGN_UP_STEP_ERROR_UPDATE = '@auth/SIGN_UP_STEP_UPDATE_ERROR';

export const isSignUpLoading = state => state.auth.signUp.loading;
export const getSignUpError = state => state.auth.signUp.error;
export const getSignUpStep = state => state.auth.signUp.step;
export const getSignUpLastValidStep = state => state.auth.signUp.lastValidStep;
export const getSignUpData = state => state.auth.signUp.data;

export const requestGoBackStep = ({
    step,
    hasPreviousStep,
}) => ({
    type: SIGN_UP_GO_BACK_STEP,
    payload: { step, hasPreviousStep },
});

export const setSignUpStep = ({ step }) => ({
    type: SIGN_UP_STEP_SET,
    payload: { step },
});

export const setSignUpData = ({ data }) => ({
    type: SIGN_UP_DATA_SET,
    payload: { data },
});

export const requestSignUpStepSubmit = ({
    step,
    data,
    hasNextStep,
}) => ({
    type: SIGN_UP_STEP_SUBMIT_REQUESTED,
    payload: { step, data, hasNextStep },
});

export const acceptSignUpStepSubmit = ({
    step,
    data,
    hasNextStep,
}) => ({
    type: SIGN_UP_STEP_SUBMIT_ACCEPTED,
    payload: { step, data, hasNextStep },
});

export const rejectSignUpStepSubmit = ({
    step,
    error,
}) => ({
    type: SIGN_UP_STEP_SUBMIT_REJECTED,
    payload: { step, error },
});

export const updateSignUpStepError = ({
    step,
    error,
}) => ({
    type: SIGN_UP_STEP_ERROR_UPDATE,
    payload: { step, error },
});

export const resetSignUp = () => ({
    type: SIGN_UP_RESET,
    payload: {},
});

export const submitSignUp = () => ({
    type: SIGN_UP_SUBMITTED,
    payload: {},
});

export const acceptSignUp = ({ user }) => ({
    type: SIGN_UP_ACCEPTED,
    payload: { user },
});

export const rejectSignUp = ({ error }) => ({
    type: SIGN_UP_REJECTED,
    payload: { error },
});

export const issueSignUpConfirmation = ({ username }) => ({
    type: SIGN_UP_CONFIRMATION_ISSUED,
    payload: { username },
});

export const raiseSignUpUnknownException = ({ message }) => ({
    type: SIGN_UP_UNKNOWN_EXCEPTION_RAISED,
    payload: { message },
});

export const validateUsername = ({ username, error }) => ({
    type: SIGN_UP_VALIDATE_USERNAME,
    payload: { username, error },
});

const updateError = (state = {}, action) => ({ ...state, error: action.payload.message });
const updateStepError = (state = {}, action) => ({
    ...state,
    loading: false,
    error: action.payload.error,
});

const initialState = {
    error: null,
    step: 1,
    lastValidStep: 0,
    data: {},
    loading: false,
};

export const signUpReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [SIGN_UP_STEP_SUBMIT_REQUESTED]: state => ({ ...state, loading: true }),
    [SIGN_UP_STEP_SUBMIT_ACCEPTED]: (state, action) => ({
        ...state,
        loading: false,
        step: action.payload.hasNextStep ? action.payload.step + 1 : action.payload.step,
        lastValidStep: Math.max(action.payload.step, state.lastValidStep),
        data: {
            ...state.data,
            ...action.payload.data,
        },
    }),
    [SIGN_UP_STEP_SUBMIT_REJECTED]: updateStepError,
    [SIGN_UP_STEP_ERROR_UPDATE]: updateStepError,
    [SIGN_UP_STEP_SET]: (state, action) => ({
        ...state,
        step: action.payload.step,
    }),
    [SIGN_UP_DATA_SET]: (state, action) => ({
        ...state,
        step: 1,
        data: action.payload.data,
    }),
    [SIGN_UP_GO_BACK_STEP]: (state, action) => ({
        ...state,
        step: action.payload.hasPreviousStep ? action.payload.step - 1 : action.payload.step,
    }),
    [SIGN_UP_RESET]: () => initialState,
    [SIGN_UP_UNKNOWN_EXCEPTION_RAISED]: updateError,
    [SIGN_UP_SUBMITTED]: state => ({ ...state, loading: true }),
    [SIGN_UP_ACCEPTED]: state => ({ ...state, loading: false }),
    [SIGN_UP_CONFIRMATION_ISSUED]: state => ({ ...state, loading: false }),
});
